import { styled } from '~/app/components'
import { Typography } from '@yanolja-rnd/ya-com-core'

export const TicketPanel = styled.article`
  padding: 1rem 2rem 2rem;
  background: ${({ theme }) => theme.color.white};
  border-bottom: 1px solid ${({ theme }) => theme.color.gray200};
`

export const TicketHeader = styled.header`
  background-color: ${({ theme }) => theme.color.gray900};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.6rem;
  color: ${({ theme }) => theme.color.white};
  height: 4rem;
`

export const TicketHeaderText = styled.div`
  padding-top: 0.1rem;
  ${Typography('body1').bold};
`

export const TicketHeaderImages = styled.div`
  display: flex;
  align-items: center;
`

export const TicketHeaderImagesDivider = styled.div`
  height: 1rem;
  width: 0.1rem;
  margin: 0 0.4rem;
  background-color: ${({ theme }) => theme.color.gray600};
`

export const TimePanel = styled.section`
  padding: 3.6rem 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.color.gray900};
  margin-bottom: 2.4rem;

  & .location {
    height: 3.4rem;
    position: relative;
    text-overflow: ellipsis;
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    ${Typography('headline3').bold};
  }
  & .time {
    height: 2.1rem;
    ${Typography('subtitle2').bold};
  }

  @media (max-width: 361px) {
    & .location {
      ${Typography('subtitle1').bold};
    }
  }
`

export const TimePanelSubGroup = styled.div`
  text-align: center;
  flex: 1;
`

export const TicketTypes = styled.div`
  margin: 0 2.4rem 2rem 2.4rem;
  padding-top: 2.3rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-top: dashed 1px ${({ theme }) => theme.color.gray200};
  @media (max-width: ${({ theme }) => theme.unit.PC_WIDTH}px) {
    padding-top: 1.1rem;
  }
`

export const TicketType = styled.div`
  flex: 25%;
  min-width: 9rem;

  @media (max-width: ${({ theme }) => theme.unit.PC_WIDTH}px) {
    flex: 50%;
    :nth-of-type(-n + 2) {
      padding-bottom: 1.4rem;
    }
    :nth-of-type(n + 3) {
      padding-top: 1.1rem;
      border-top: dashed 1px ${({ theme }) => theme.color.gray200};
    }

    :nth-of-type(2n) {
      padding-left: 1.5rem;
    }

    :nth-of-type(2n + 1) {
      padding-left: 1.4rem;
    }
  }

  & .title {
    color: ${({ theme }) => theme.color.gray600};
    ${Typography('body2').regular}
    margin-bottom: 0.6rem;
  }

  & .content {
    display: flex;
    align-items: start;
    height: 1.6rem;
    ${Typography('body1').regular}

    & .logo {
      margin-right: 0.4rem;
    }

    & .number {
      display: inline-block;
      ${Typography('subtitle3').regular}
    }
  }
`

export const SeatInformationPanel = styled.div`
  flex: 0 0 auto;
  padding: 0 2.4rem;
`

export const SeatInformation = styled.div`
  display: flex;
  border-radius: 0.4rem;
  background: ${({ theme }) => theme.color.gray50};
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 0 1.8rem;
  margin-bottom: 0.4rem;

  :last-of-type {
    margin-bottom: 0;
  }
`

export const SeatInformationTextGroup = styled.div`
  ${Typography('subtitle2').regular};
  color: ${({ theme }) => theme.color.gray900};
  margin: 0.8rem 0;
  flex: 1;
  text-align: center;

  .text {
    height: 2.2rem;
  }

  .direction {
    ${Typography('subtitle3').regular};
  }
`

export const SeatInformationSubText = styled.div`
  ${Typography('body2').regular};
  color: ${({ theme }) => theme.color.gray600};
  margin-bottom: 0.2rem;
  height: 1.6rem;
`
